(() => {
  const SELECTORS = {
    root: '[data-sort-popup]',
    toggle: '[data-sort-popup-toggle]',
    panel: '[data-sort-popup-panel]',
    option: '.custom-sort-popup__option',
    optionInput: '[data-sort-popup-option]',
    reset: '[data-sort-popup-reset]',
    native: '.custom-sort-popup__native',
    current: '[data-sort-popup-current]'
  };

  const getRoot = (target) => target.closest(SELECTORS.root);

  const closePopup = (root) => {
    if (!root) return;

    const toggle = root.querySelector(SELECTORS.toggle);
    const panel = root.querySelector(SELECTORS.panel);

    if (!toggle || !panel) return;

    panel.hidden = true;
    panel.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    root.classList.remove('is-open');
  };

  const openPopup = (root) => {
    if (!root) return;

    document.querySelectorAll(SELECTORS.root).forEach((popup) => {
      if (popup !== root) closePopup(popup);
    });

    const toggle = root.querySelector(SELECTORS.toggle);
    const panel = root.querySelector(SELECTORS.panel);

    if (!toggle || !panel) return;

    panel.hidden = false;
    panel.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    root.classList.add('is-open');
  };

  const syncSelection = (root, value, dispatchEvents) => {
    if (!root || !value) return;

    const options = Array.from(root.querySelectorAll(SELECTORS.optionInput));
    const selectedOption = options.find((option) => option.value === value);

    if (!selectedOption) return;

    options.forEach((option) => {
      option.checked = option === selectedOption;
    });

    const currentLabel = root.querySelector(SELECTORS.current);
    const labelText = selectedOption.closest('label')?.querySelector('span')?.textContent?.trim();
    if (currentLabel && labelText) {
      currentLabel.textContent = labelText;
    }

    const nativeSelect = root.querySelector(SELECTORS.native);
    if (nativeSelect) {
      nativeSelect.value = value;
      if (dispatchEvents) {
        nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (dispatchEvents) {
      const sortContainer = root.closest('.products-toolbar__sort');
      if (sortContainer) {
        sortContainer.dispatchEvent(new CustomEvent('change', {
          bubbles: true,
          detail: {
            selectedValue: value
          }
        }));
      }
    }
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest(SELECTORS.toggle);
    if (toggle) {
      const root = getRoot(toggle);
      if (!root) return;

      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      if (isExpanded) {
        closePopup(root);
      } else {
        openPopup(root);
      }
      return;
    }

    const resetButton = event.target.closest(SELECTORS.reset);
    if (resetButton) {
      const root = getRoot(resetButton);
      if (!root) return;

      const defaultValue = root.dataset.defaultValue;
      syncSelection(root, defaultValue, true);
      closePopup(root);
      return;
    }

    const optionLabel = event.target.closest(SELECTORS.option);
    if (optionLabel) {
      const root = getRoot(optionLabel);
      if (!root) return;

      const optionInput = optionLabel.querySelector(SELECTORS.optionInput);
      if (!optionInput) return;

      syncSelection(root, optionInput.value, true);
      closePopup(root);
      return;
    }

    document.querySelectorAll(`${SELECTORS.root}.is-open`).forEach((root) => {
      if (!root.contains(event.target)) {
        closePopup(root);
      }
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll(`${SELECTORS.root}.is-open`).forEach((root) => {
      closePopup(root);
    });
  });

  const syncFromInitialState = () => {
    document.querySelectorAll(SELECTORS.root).forEach((root) => {
      const selectedOption = root.querySelector(`${SELECTORS.optionInput}:checked`);
      const initialValue = selectedOption?.value || root.querySelector(SELECTORS.native)?.value;
      syncSelection(root, initialValue, false);
      closePopup(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFromInitialState);
  } else {
    syncFromInitialState();
  }

  document.addEventListener('on:facet-filters:updated', syncFromInitialState);
})();
